module.exports = __webpack_public_path__ + "static/media/airplane-img.6ce2d110.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/airplane-img.svg
// module id = 323
// module chunks = 0